<template>
  <modal :name="nombreModal" :adaptive="true" height="auto" width="720px">
    <div class="tip">
      <div class="modal-header tip-cabecera">
        <h4>{{ $t("tituloSinTipo") }}</h4>
        <p>{{ $t("ayudaSinTipo") }}</p>
      </div>

      <div class="modal-body tip-cuerpo">
        <div class="tip-barra">
          <button type="button" class="tip-enlace" @click="seleccionarTodas()">
            {{ $t("seleccionarTodas") }}
          </button>
          <span class="tip-sep">·</span>
          <button type="button" class="tip-enlace" @click="seleccionarNinguna()">
            {{ $t("seleccionarNinguna") }}
          </button>
        </div>

        <div class="tip-lista" v-if="sinTipo.length">
          <label
            v-for="tag in sinTipo"
            :key="'t' + tag.id"
            class="tip-fila"
            :class="{ puesta: !!marcadas[tag.id] }"
          >
            <input
              type="checkbox"
              :checked="!!marcadas[tag.id]"
              @change="marcar(tag.id, $event.target.checked)"
            />
            <span class="tip-nombre" :class="{ anonima: !tag.nombre }">
              {{ tag.nombre || $t("sinNombre") }}
            </span>
            <!-- Las pistas son lo que permite acertar con la familia: quien la usa y que
                 cuelga de ella. Sin esto el usuario elige a ciegas. -->
            <span class="tip-pistas">
              <em v-if="tag.materiasPrimas">
                {{ $tc("pistaMateriasPrimas", tag.materiasPrimas, { n: tag.materiasPrimas }) }}
              </em>
              <em v-if="hijasDe(tag).total">
                {{ $tc("pistaHijas", hijasDe(tag).total, {
                  n: hijasDe(tag).total,
                  familia: nombreTipo(hijasDe(tag).familia)
                }) }}
              </em>
              <em class="flojo" v-if="!tag.materiasPrimas && !hijasDe(tag).total">
                {{ $t("pistaNadie") }}
              </em>
            </span>
          </label>
        </div>

        <p class="tip-vacio" v-else>{{ $t("sinTipoNadaQueVer") }}</p>

        <p class="tip-error" v-if="error">{{ error }}</p>
      </div>

      <div class="modal-footer tip-pie">
        <div class="tip-familia">
          <label>
            {{ $t("queFamiliaLesCorresponde") }}
            <span class="info" tabindex="0" :aria-label="$t('queEsCadaFamilia')">
              i
              <span class="info-globo" role="tooltip">
                <b>{{ $t("materiaPrima") }}</b> — {{ $t("ayudaFamiliaMateriaPrima") }}<br /><br />
                <b>{{ $t("proveedor") }}</b> — {{ $t("ayudaFamiliaProveedor") }}
              </span>
            </span>
          </label>

          <div class="tip-familias">
            <button
              type="button"
              :aria-pressed="tipo === 'A' ? 'true' : 'false'"
              @click="tipo = 'A'"
            >
              {{ $t("materiaPrima") }}
            </button>
            <button
              type="button"
              :aria-pressed="tipo === 'P' ? 'true' : 'false'"
              @click="tipo = 'P'"
            >
              {{ $t("proveedor") }}
            </button>
          </div>
        </div>

        <div class="tip-botones">
          <button type="button" class="btn btn-claro" :disabled="ocupado" @click="cerrar()">
            {{ $t("cerrar") }}
          </button>
          <button
            type="button"
            class="btn btn-verde"
            :disabled="ocupado || !cuantasMarcadas || !tipo"
            @click="confirmar()"
          >
            {{ $tc("asignarACuantas", cuantasMarcadas, { n: cuantasMarcadas }) }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
/**
 * Asignar la familia a las etiquetas que no la tienen.
 *
 * Una etiqueta sin `type` no es ni de materia prima ni de proveedor, asi que no sale en
 * ninguna lista de las pantallas, que filtran por familia. Lo grave no es que no se vea
 * ella: es que ACTUA DE PADRE de etiquetas reales, y el recorrido del arbol corta la rama
 * ahi, de modo que desaparece del panel todo lo que cuelga de ella. En el negocio 6730
 * una sola etiqueta asi escondia 34 etiquetas con 255 materias primas dentro.
 *
 * La familia solo se PONE, nunca se cambia: el API descarta del UPDATE cualquier etiqueta
 * que ya tenga la suya, asi que desde aqui no se puede mover una etiqueta usada de una
 * familia a la otra.
 *
 * El listado sale de las etiquetas que ya tiene la pantalla -no hace falta pedirlas otra
 * vez-, y las pistas de cada fila (materias primas que la usan, etiquetas que cuelgan y
 * de que familia son) se calculan del mismo array. Son lo que permite acertar: si tiene
 * materias primas colgando es de materia prima, y si sus hijas son de proveedor, ella
 * tambien.
 *
 * Este componente NO escribe: emite `confirmar` con {ids, type}.
 */
export default {
  name: "EtiquetasSinTipoModal",

  props: {
    nombreModal: { type: String, default: "modalSinTipo" },
    // Todas las etiquetas del negocio, tal como las devuelve getBusinessTags.
    etiquetas: { type: Array, default: () => [] },
    ocupado: { type: Boolean, default: false }
  },

  data() {
    return {
      marcadas: {},
      tipo: "",
      error: ""
    };
  },

  computed: {
    sinTipo() {
      return this.etiquetas
        .filter(function(t) {
          return t.tipo !== "A" && t.tipo !== "P";
        })
        .sort(function(a, b) {
          // Primero las que arrastran mas: son las que mas rama estan escondiendo.
          if (b.materiasPrimas !== a.materiasPrimas) {
            return b.materiasPrimas - a.materiasPrimas;
          }

          return (a.nombre || "").localeCompare(b.nombre || "");
        });
    },

    idsMarcados() {
      let vm = this;

      return this.sinTipo
        .filter(function(t) {
          return !!vm.marcadas[t.id];
        })
        .map(function(t) {
          return t.id;
        });
    },

    cuantasMarcadas() {
      return this.idsMarcados.length;
    }
  },

  methods: {
    abrir() {
      this.marcadas = {};
      this.tipo = "";
      this.error = "";

      this.$modal.show(this.nombreModal);
    },

    cerrar() {
      this.$modal.hide(this.nombreModal);
    },

    mostrarError(mensaje) {
      this.error = mensaje || this.$t("errorInesperado");
    },

    /**
     * Cuantas etiquetas cuelgan de esta y de que familia son. Si son todas de la misma,
     * se dice cual: es la pista mas fiable para deducir la familia de la madre.
     */
    hijasDe(tag) {
      let hijas = this.etiquetas.filter(function(t) {
        return t.parentCode && t.parentCode === tag.code && t.id !== tag.id;
      });

      let familias = {};

      hijas.forEach(function(t) {
        familias[t.tipo] = true;
      });

      let claves = Object.keys(familias);

      return { total: hijas.length, familia: claves.length === 1 ? claves[0] : "" };
    },

    nombreTipo(tipo) {
      if (tipo === "A") {
        return this.$t("materiaPrima");
      }

      if (tipo === "P") {
        return this.$t("proveedor");
      }

      return this.$t("sinTipo");
    },

    // Vue 2 no ve las claves nuevas de un objeto, de ahi el $set.
    marcar(id, puesta) {
      this.$set(this.marcadas, id, !!puesta);
    },

    seleccionarTodas() {
      let vm = this;

      this.sinTipo.forEach(function(t) {
        vm.$set(vm.marcadas, t.id, true);
      });
    },

    seleccionarNinguna() {
      this.marcadas = {};
    },

    confirmar() {
      if (!this.cuantasMarcadas || !this.tipo) {
        return;
      }

      this.error = "";
      this.$emit("confirmar", { ids: this.idsMarcados, type: this.tipo });
    }
  }
};
</script>

<style scoped>
/* ---------------------------------------------------------------------------
   Etiquetas sin familia

   Mismo reparto que el modal de recolocar materias primas: la lista con su
   scroll en el cuerpo y la decision en el pie, que no se mueve. La diferencia
   es que aqui la decision son dos botones y no un desplegable: son dos opciones
   excluyentes, se ven las dos a la vez y es la eleccion que hay que explicar.
   --------------------------------------------------------------------------- */
.tip-cabecera {
    padding: 16px 20px;
    background: #f7f9fb;
    border-bottom: 1px solid #e6e9ef;
}

.tip-cabecera h4 {
    margin: 0;
    font-size: 1.05em;
    font-weight: 600;
    color: #2c3e50;
}

.tip-cabecera p {
    margin: 5px 0 0;
    font-size: 0.86em;
    color: #4a5765;
}

.tip-cuerpo {
    padding: 16px 20px;
}

.tip-barra {
    margin-bottom: 10px;
    font-size: 0.82em;
    color: #8b96a3;
}

.tip-enlace {
    border: 0;
    background: none;
    padding: 0;
    font-size: 1em;
    color: #4a5765;
    text-decoration: underline;
}

.tip-enlace:hover {
    color: #009982;
}

.tip-sep {
    margin: 0 6px;
    color: #c3cbd5;
}

.tip-lista {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #e6e9ef;
    border-radius: 3px;
}

.tip-fila {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0;
    padding: 9px 12px;
    border-bottom: 1px solid #f0f2f6;
    font-weight: 400;
    cursor: pointer;
}

.tip-fila:last-child {
    border-bottom: 0;
}

.tip-fila:hover {
    background: #f7f9fb;
}

.tip-fila.puesta {
    background: rgba(0, 153, 130, 0.07);
}

.tip-fila input {
    margin: 0;
    flex: 0 0 auto;
}

.tip-nombre {
    flex: 1 1 auto;
    font-size: 0.9em;
    color: #2c3e50;
}

/* Hay dos filas sin nombre en las 159.749 de produccion: se dice, no se deja el
   hueco en blanco. */
.tip-nombre.anonima {
    color: #b3bcc6;
    font-style: italic;
}

.tip-pistas {
    flex: 0 0 auto;
    display: flex;
    gap: 12px;
    font-size: 0.8em;
    color: #4a5765;
}

.tip-pistas em {
    font-style: normal;
}

.tip-pistas em.flojo {
    color: #b3bcc6;
    font-style: italic;
}

.tip-vacio {
    margin: 0;
    padding: 24px 0;
    text-align: center;
    font-size: 0.88em;
    color: #98a2ad;
}

.tip-error {
    margin: 12px 0 0;
    padding: 9px 12px;
    border-radius: 4px;
    background: rgba(161, 58, 47, 0.1);
    border: 1px solid rgba(161, 58, 47, 0.22);
    color: #a13a2f;
    font-size: 0.85em;
}

.tip-pie {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 14px;
    padding: 14px 20px;
    background: #f7f9fb;
    border-top: 1px solid #e6e9ef;
}

.tip-familia {
    flex: 0 1 auto;
    text-align: left;
}

.tip-familia > label {
    display: block;
    font-size: 0.94em;
    color: #2c3e50;
    font-weight: 500;
    margin-bottom: 8px;
}

/* Las dos familias, como en el alta: la puesta en turquesa. */
.tip-familias {
    display: flex;
    gap: 8px;
}

.tip-familias button {
    border: 1px solid #dde2e9;
    background: #fff;
    border-radius: 3px;
    padding: 8px 16px;
    font-size: 0.86em;
    color: #4a5765;
}

.tip-familias button:hover {
    border-color: #009982;
    color: #009982;
}

.tip-familias button[aria-pressed="true"] {
    background: #009982;
    border-color: #009982;
    color: #fff;
    font-weight: 600;
}

/* ---- La (i), igual que en el alta de etiqueta ---- */
.info {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 15px;
    height: 15px;
    margin-left: 4px;
    border: 1px solid #c3cbd5;
    border-radius: 50%;
    font-size: 10px;
    font-weight: 700;
    font-style: italic;
    color: #8b96a3;
    cursor: help;
    position: relative;
}

.info:hover,
.info:focus {
    border-color: #009982;
    color: #009982;
    outline: none;
}

/* Encima del icono y no debajo: aqui la (i) esta en el pie del modal, asi que
   debajo se saldria por el borde inferior. */
.info-globo {
    display: none;
    position: absolute;
    left: -6px;
    bottom: calc(100% + 8px);
    width: 300px;
    max-width: calc(100vw - 60px);
    padding: 10px 12px;
    background: #2c3e50;
    color: #fff;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 400;
    font-style: normal;
    line-height: 1.45;
    text-align: left;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
    z-index: 10;
}

.info:hover .info-globo,
.info:focus .info-globo {
    display: block;
}

.info-globo::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 11px;
    border: 5px solid transparent;
    border-top-color: #2c3e50;
}

.tip-botones {
    display: flex;
    gap: 8px;
    flex: 0 0 auto;
}

.btn-verde {
    background: #009982;
    border: 1px solid #009982;
    color: #fff;
    border-radius: 3px;
    padding: 8px 16px;
    font-size: 0.88em;
    font-weight: 600;
}

.btn-verde:disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.btn-claro {
    background: #fff;
    border: 1px solid #dde2e9;
    color: #4a5765;
    border-radius: 3px;
    padding: 8px 16px;
    font-size: 0.88em;
}

.btn-claro:hover:not(:disabled) {
    border-color: #009982;
    color: #009982;
}

.btn-claro:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/pages/Widgets/Etiquetas/EtiquetasSinTipoModal.vue